import { render } from "./TheRechargesDetails.vue?vue&type=template&id=7ca796f2"
import script from "./TheRechargesDetails.vue?vue&type=script&lang=js"
export * from "./TheRechargesDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__